import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const LabelCard = styled.div`
  padding-bottom: 20px;
`
export const Title = styled.span`
  color: ${colors.blue};
  font-size: 15px;
`

export const Subtitle = styled.span`
  color: ${colors.grayDark};
  font-size: 14px;
  font-weight: 700;
`
